/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AdvancedSearchOwner } from './';
import {
    AdvancedSearchOwnerFromJSON,
    AdvancedSearchOwnerFromJSONTyped,
    AdvancedSearchOwnerToJSON,
} from './';
import type { MatchingCriteriaResponse } from './';
import {
    MatchingCriteriaResponseFromJSON,
    MatchingCriteriaResponseFromJSONTyped,
    MatchingCriteriaResponseToJSON,
} from './';
import type { OpportunityScoreAnalysis } from './';
import {
    OpportunityScoreAnalysisFromJSON,
    OpportunityScoreAnalysisFromJSONTyped,
    OpportunityScoreAnalysisToJSON,
} from './';
import type { ProfileResponse } from './';
import {
    ProfileResponseFromJSON,
    ProfileResponseFromJSONTyped,
    ProfileResponseToJSON,
} from './';
import type { ProjectCriteriaResponse } from './';
import {
    ProjectCriteriaResponseFromJSON,
    ProjectCriteriaResponseFromJSONTyped,
    ProjectCriteriaResponseToJSON,
} from './';
import type { StoredFile } from './';
import {
    StoredFileFromJSON,
    StoredFileFromJSONTyped,
    StoredFileToJSON,
} from './';
import type { SubmissionState } from './';
import {
    SubmissionStateFromJSON,
    SubmissionStateFromJSONTyped,
    SubmissionStateToJSON,
} from './';
import type { Workflow } from './';
import {
    WorkflowFromJSON,
    WorkflowFromJSONTyped,
    WorkflowToJSON,
} from './';

/**
 * 
 * @export
 * @interface AdvancedSearchResponse
 */
export interface AdvancedSearchResponse {
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchResponse
     */
    briefId: string;
    /**
     * 
     * @type {Date}
     * @memberof AdvancedSearchResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {AdvancedSearchOwner}
     * @memberof AdvancedSearchResponse
     */
    owner: AdvancedSearchOwner;
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchResponse
     */
    prompt?: string;
    /**
     * 
     * @type {MatchingCriteriaResponse}
     * @memberof AdvancedSearchResponse
     */
    matching: MatchingCriteriaResponse;
    /**
     * 
     * @type {ProjectCriteriaResponse}
     * @memberof AdvancedSearchResponse
     */
    project: ProjectCriteriaResponse;
    /**
     * 
     * @type {StoredFile}
     * @memberof AdvancedSearchResponse
     */
    attachment?: StoredFile;
    /**
     * 
     * @type {SubmissionState}
     * @memberof AdvancedSearchResponse
     */
    submissionState: SubmissionState;
    /**
     * 
     * @type {Array<ProfileResponse>}
     * @memberof AdvancedSearchResponse
     */
    selection: Array<ProfileResponse>;
    /**
     * 
     * @type {Workflow}
     * @memberof AdvancedSearchResponse
     */
    workflow: Workflow;
    /**
     * 
     * @type {OpportunityScoreAnalysis}
     * @memberof AdvancedSearchResponse
     */
    opportunityScoreAnalysis?: OpportunityScoreAnalysis;
}

/**
 * Check if a given object implements the AdvancedSearchResponse interface.
 */
export function instanceOfAdvancedSearchResponse(value: object): value is AdvancedSearchResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('briefId' in value) || value['briefId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    if (!('matching' in value) || value['matching'] === undefined) return false;
    if (!('project' in value) || value['project'] === undefined) return false;
    if (!('submissionState' in value) || value['submissionState'] === undefined) return false;
    if (!('selection' in value) || value['selection'] === undefined) return false;
    if (!('workflow' in value) || value['workflow'] === undefined) return false;
    return true;
}

export function AdvancedSearchResponseFromJSON(json: any): AdvancedSearchResponse {
    return AdvancedSearchResponseFromJSONTyped(json, false);
}

export function AdvancedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdvancedSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'briefId': json['briefId'],
        'createdAt': (new Date(json['createdAt'])),
        'owner': AdvancedSearchOwnerFromJSON(json['owner']),
        'prompt': json['prompt'] == null ? undefined : json['prompt'],
        'matching': MatchingCriteriaResponseFromJSON(json['matching']),
        'project': ProjectCriteriaResponseFromJSON(json['project']),
        'attachment': json['attachment'] == null ? undefined : StoredFileFromJSON(json['attachment']),
        'submissionState': SubmissionStateFromJSON(json['submissionState']),
        'selection': ((json['selection'] as Array<any>).map(ProfileResponseFromJSON)),
        'workflow': WorkflowFromJSON(json['workflow']),
        'opportunityScoreAnalysis': json['opportunityScoreAnalysis'] == null ? undefined : OpportunityScoreAnalysisFromJSON(json['opportunityScoreAnalysis']),
    };
}

export function AdvancedSearchResponseToJSON(value?: AdvancedSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'briefId': value['briefId'],
        'createdAt': ((value['createdAt']).toISOString()),
        'owner': AdvancedSearchOwnerToJSON(value['owner']),
        'prompt': value['prompt'],
        'matching': MatchingCriteriaResponseToJSON(value['matching']),
        'project': ProjectCriteriaResponseToJSON(value['project']),
        'attachment': StoredFileToJSON(value['attachment']),
        'submissionState': SubmissionStateToJSON(value['submissionState']),
        'selection': ((value['selection'] as Array<any>).map((v) => ProfileResponseToJSON(v))),
        'workflow': WorkflowToJSON(value['workflow']),
        'opportunityScoreAnalysis': OpportunityScoreAnalysisToJSON(value['opportunityScoreAnalysis']),
    };
}

